
const imageUrl = (title) => {
  return `/imgs/case/warehouse/${title}.png`;
};

const data = {
  introduce: {
    img: imageUrl('introduce'),
    title: '仓配服务说明',
    description: [
      {
        title: 'Inbound：',
        description: '正向：从工厂发货到3PL的仓库，再按需从两个仓库配送给客户。运输方式包括整车、零担等。\n逆向：从3PL仓库退货到工厂。'
      },
      {
        title: 'Outbound：',
        description: '正向：按客户订单需要和库存情况，给客户配送。运输方式包括整车、零担和速运等。\n逆向：从客户处以整车、零担、速运等方式退货到3PL仓库。'
      }
    ]
  },
  method: imageUrl('method'),
  value: [
    {
      title: '仓配一体化管理提升50%作业效率',
      description: '实现仓配一体化，规避了仓库等车或车等仓库拣货的情况，大幅度提升效率。',
      img: imageUrl('value1')
    },
    {
      title: '集群化的运输管理，降低40%的运输成本',
      description: '划分配送区域，将订单按区域归集、配送。',
      img: imageUrl('value2')
    },
    {
      title: '支持20多种订单可视化管理，适配正、逆向多种运输场景',
      description: '管理正向、逆向4个大类，20种类型的订单，适配提货、干线、配送等各种运输场景。',
      img: imageUrl('value3')
    },
    {
      title: '支持费用自动化，准确率提升40%以上',
      description: '可根据客户协议自动计算运费，只需要人工审核，节省了制作的工时。',
      img: imageUrl('value4')
    }
  ]
};

export default data;


// WEBPACK FOOTER //
// ./src/routes/Case/config/warehouse.js